import React, { FC, PropsWithChildren } from "react";
import { Loader } from ".";

interface LoadableWrapperProps {
  loading: boolean;
}

export const LoadableWrapper: FC<PropsWithChildren<LoadableWrapperProps>> = ({ children, loading }) => (
  <>
    {loading
      ? <Loader />
      : children 
    }
  </>
);